
import React from 'react'
import useStyles from './Styles'

function ReportAbuse({src}:{src:string}) {
  const { classes } = useStyles()

  return (
    <div className={classes.outerContainer} style={{ width: '100%' }}>
      <div
        className={classes.innerContainer}
        style={{ width: '100%', height: '650px' }}
      >
        <iframe
          src={src}
          data-testid="iframe"
          allow="microphone; camera"
          height={'100%'}
          width={'100%'}
          title="Trusted Flagger - Report Tool"
          data-origwidth=""
          data-origheight=""
        ></iframe>
      </div>
    </div>
  )
}

export default ReportAbuse
